import React from 'react';
import {
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import { Search } from '@mui/icons-material';

const InventoryFilters = ({ searchTerm, onSearchChange, statusFilter, onStatusChange, totalItems }) => {
  return (
    <Card sx={{ mb: 4, borderRadius: 3 }}>
      <CardContent sx={{ p: 3 }}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              placeholder="Wyszukaj produkty..."
              value={searchTerm}
              onChange={onSearchChange}
              InputProps={{
                startAdornment: <Search sx={{ mr: 1, color: 'text.secondary' }} />,
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              select
              fullWidth
              label="Status"
              value={statusFilter}
              onChange={onStatusChange}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                },
              }}
            >
              <option value="all">Wszystkie</option>
              <option value="available">Dostępne</option>
              <option value="low_stock">Niski stan</option>
              <option value="out_of_stock">Brak w magazynie</option>
            </TextField>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
              Znaleziono: {totalItems} produktów
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default InventoryFilters; 